import { Accordion, AccordionDetails, AccordionSummary, Typography, TextField, TextareaAutosize, Button, IconButton } from '@mui/material';
import React, { useState } from 'react';
import ImageUploaderNew from './ImageUploaderNew';
import { GriderLayout } from './GriderLayout';
import { DndProvider } from 'react-dnd';
import { TouchBackend } from 'react-dnd-touch-backend';
import AIWritingGenerator from './AIWritingGenerator';
import { styled } from '@mui/system';
import DeleteIcon from '@mui/icons-material/Delete';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

const HtmlForm = ({ data, onUpdate }) => {
  const [listData, setListData] = useState(data || {});
  const [isDragging, setIsDragging] = useState(false);

  const handleItemChange = (index, field, value) => {
    console.log('index',index,'field',field,'value',value);
    const updatedItems = [...listData.items];
    updatedItems[index] = { ...updatedItems[index], [field]: value };
    setListData({ ...listData, items: updatedItems });
  };
  const handleItemDelete = (index,event) => {
    event.stopPropagation();
    const newItems = [...listData.items];
    newItems.splice(index, 1);
    setListData({ ...listData, items: newItems });
  };

  const handleSave = () => {
    onUpdate(listData);
  };
  
  const StyledAccordionSummary = styled(AccordionSummary)({
    justifyContent: 'space-between',
    alignItems: 'center',
  });

  const StyledIconButton = styled(IconButton)({
    //marginRight: 'auto',
    cursor: 'grab !important',
  });

  const handleAddItem = () => {
    const newItem = {
      title: "",
      content: "",
      idx: listData.items.length,
      button: {
          label: "More info",
          type: "url",
          link: "#",
      },
      image: {
          id: "",
          description: "",
          alt_description: "",
          url: "",
          author: "",
          authorLink: "",
          type: "unsplash",
          download: "",
          urlSmall: ""
      }
    };
    setListData({ ...listData, items: [...listData.items, newItem] });
  };

  
  const handleSelectImage = (image) => {
   console.log('image',image)
    const updatedItems = listData.items.map((item,index) =>
        index === image.idx ? { ...item, image: {
            ...item.image,
            id: (image.image.id) ? image.image.id : null,
            description: (image.image.description) ? image.image.description : '',
            alt_description: (image.image.alt_description) ? image.image.alt_description : '',
            url: (image.image.urls && image.image.urls.regular) ? image.image.urls.regular : '',
            urlSmall: (image.image.urls && image.image.urls.thumb) ? image.image.urls.thumb : '',
            author: (image.image.user && image.image.user.name) ? image.image.user.name : '',
            authorLink: (image.image.user && image.image.user.links && image.image.user.links.html) ? image.image.user.links.html : '',
            type: 'unsplash',
            download: (image.image.links && image.image.links.download) ? image.image.links.download : '',
        } } : item
    );
    setListData({ ...listData, items: updatedItems });
  };
  const handleSelectIcon = (icon) => {
   console.log('icon',icon)
    const updatedItems = listData.items.map((item,index) =>
        index === icon.idx ? { ...item, icon: {
            ...item.icon,
            id: (icon.icon.id) ? icon.icon.id : null,
            description: (icon.icon.description) ? icon.icon.description : '',
            alt_description: (icon.icon.alt_description) ? icon.icon.alt_description : '',
            url: (icon.icon.urls && icon.icon.urls.regular) ? icon.icon.urls.regular : '',
            urlSmall: (icon.icon.urls && icon.icon.urls.thumb) ? icon.icon.urls.thumb : '',
            author: (icon.icon.user && icon.icon.user.name) ? icon.icon.user.name : '',
            authorLink: (icon.icon.user && icon.icon.user.links && icon.icon.user.links.html) ? icon.icon.user.links.html : '',
            type: 'unsplash',
            download: (icon.icon.links && icon.icon.links.download) ? icon.icon.links.download : '',
        } } : item
    );
    setListData({ ...listData, items: updatedItems });
  };
  
  const handleDragStart = (event, index) => {
    event.stopPropagation();
    event.dataTransfer.setData('text/plain', index);
    setIsDragging(true);
};

const handleDragOver = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setIsDragging(false);
};
/*
const handleDrop = async (event, targetIndex) => {
    event.preventDefault();
    const draggedIndex = event.dataTransfer.getData('text/plain');
    const draggedItem = listData.items[draggedIndex];

    const newItems = [...listData.items];
    newItems.splice(draggedIndex, 1);
    newItems.splice(targetIndex, 0, draggedItem);

    let newListData = listData;
    newListData['items'] = newItems;
    setListData(newListData);
    onUpdate(newListData); 
};
*/

const handleDrop = async (event, targetIndex) => {
  event.preventDefault();
  const draggedIndex = event.dataTransfer.getData('text/plain');
  const draggedItem = listData.items[draggedIndex];
  const targetItem = listData.items[targetIndex];

  const newItems = [...listData.items];
  newItems[draggedIndex] = targetItem;
  newItems[targetIndex] = draggedItem;

  let newListData = {... listData, items: newItems};
  setListData(newListData);
  onUpdate(newListData); 
};


  return (
    <div>
      hi
      <GriderLayout left={'Background'} 
        right={<input
          type="color"
          value={listData.background}
          onChange={(e) => setListData({ ...listData, background: e.target.value })}
        />} 
      />
      
      <TextField
        variant="outlined"
        fullWidth 
        style={{ marginTop: 11 }}
        label={'Headline'}
        value={listData.headline}
        onChange={(e) => setListData({ ...listData, headline: e.target.value })}
      />
      <TextareaAutosize
                name="content"
                minRows={4}
                style={{width: '100%'}}
                aria-label="Content"
                placeholder="Content"
                value={listData.content}
                onChange={(e) => setListData({ ...listData, content: e.target.value })}
            />
      <TextField
          variant="outlined"
          fullWidth 
          style={{ marginTop: 11 }}
          label={'Button Label'}
          value={(listData.button) ? listData.button.label: ''}
          onChange={(e) =>
              setListData({ ...listData, button: { ...listData.button, label: e.target.value }})
          }
      />
      <TextField
          variant="outlined"
          fullWidth 
          style={{ marginTop: 11 }}
          label={'Button Link'}
          value={(listData.button) ? listData.button.link: ''}
          onChange={(e) =>
              setListData({ ...listData, button: { ...listData.button, link: e.target.value }})
          }
      />
      {/* Include other props here */}
      {listData.items &&
        listData.items.map((item, index) => (
        <>
        <Accordion
          key={index}                               
          draggable
          onDragStart={(event) => handleDragStart(event, index)}
          onDragOver={handleDragOver}
          onDrop={(event) => handleDrop(event, index)}
          onTouchStart={(event) => handleDragStart(event, index)}
          onTouchMove={handleDragOver}
          onTouchEnd={(event) => handleDrop(event, index)}
          //ref={drop} 
          style={{ opacity: isDragging ? 0.5 : 1 }}
          >
            
        <StyledAccordionSummary
          //expandIcon={}
        >
          <StyledIconButton>
            <DragIndicatorIcon />
          </StyledIconButton>
          <Typography variant="h6">{item.title}</Typography>
          <IconButton style={{marginLeft: 'auto'}} onClick={(event) => handleItemDelete(index,event)}><DeleteIcon /></IconButton>
        </StyledAccordionSummary>
        {/*
        <AccordionSummary>
          <Typography variant="h6">{item.title}</Typography>
        </AccordionSummary>
        */}
        <AccordionDetails>
          <div key={index}>
            <TextField
                variant="outlined"
                fullWidth 
                style={{ marginTop: 11 }}
                label={'Title'}
                value={item.title}
                onChange={(e) => handleItemChange(index, 'title', e.target.value)}
            />
            <TextField
                variant="outlined"
                fullWidth 
                style={{ marginTop: 11 }}
                label={'Step'}
                value={(item.step_number) ? item.step_number: ''}
                onChange={(e) =>
                    handleItemChange(index, 'step_number', e.target.value )
                }
            />
            <label>Content:</label>
            <AIWritingGenerator props={{blockType: 'list', data: item, toUpdate: 'item.content'}} onUpdate={(e) => handleItemChange(index, 'content', e)} />
            <TextareaAutosize
                name="content"
                minRows={4}
                style={{width: '100%'}}
                aria-label="Content"
                placeholder="Content"
                value={item.content}
                onChange={(e) => handleItemChange(index, 'content', e.target.value)}
            />
              <TextField
                  variant="outlined"
                  fullWidth 
                  style={{ marginTop: 11 }}
                  label={'Button Label'}
                  value={(item.button) ? item.button.label: ''}
                  onChange={(e) =>
                      handleItemChange(index, 'button', { ...item.button, label: e.target.value })
                  }
              />
              <TextField
                  variant="outlined"
                  fullWidth 
                  style={{ marginTop: 11 }}
                  label={'Button Link'}
                  value={(item.button) ? item.button.link: ''}
                  onChange={(e) =>
                      handleItemChange(index, 'button', { ...item.button, link: e.target.value })
                  }
              />
            <label>Image:</label>
            {/*<input
              type="text"
              value={item.image.url}
              onChange={(e) =>
                handleItemChange(index, 'image', { ...item.image, url: e.target.value })
              }
            />*/}
          {/*item.image && item.image.url && <img src={item.image.url} width={'100%'} />*/}
          <ImageUploaderNew blockData={item} image={item.image} onUpdateImage={(e) => handleSelectImage({idx: index, image: e})} />
          {/*<ImageUploaderNew image={item.icon} onUpdateImage={(e) => handleSelectIcon({idx: index, icon: e})} />*/}          
          <TextField
                variant="outlined"
                fullWidth 
                style={{ marginTop: 11 }}
                label={'Icon Class'}
                value={item.icon}
                onChange={(e) => handleItemChange(index, 'icon', e.target.value)}
            />
          </div>
          </AccordionDetails>
        </Accordion>
        </>
        ))}
        <button onClick={handleAddItem}>Add Item</button>
        
        <TextareaAutosize
                name="templateCode"
                minRows={4}
                style={{width: '100%', fontFamily: 'monospace !important'}}
                aria-label="Custom Template Code"
                placeholder='
                <div class="container bg-dark text-light">
                  Hello, {{headline}}!
                  {% loop items as item %}
                  <div>{{item.title}}</div>
                  {% endloop %}
                  </div>
                '
                value={listData.templateCode}
                onChange={(e) => setListData({ ...listData, templateCode: e.target.value })}
            />          
          <GriderLayout left={'Use Custom Template'} 
            right={<input
              type="checkbox"
              value={true}
              checked={listData.useCustomTemplate}
              onChange={(e) => setListData({ ...listData, useCustomTemplate: e.target.checked })}
            />} 
          />
          <TextareaAutosize
                  name="gridCss"
                  minRows={4}
                  style={{width: '100%', fontFamily: 'monospace !important'}}
                  aria-label="Custom grid CSS"
                  placeholder='Put your CSS here'
                  value={listData.customGridCss}
                  onChange={(e) => setListData({ ...listData, customGridCss: e.target.value })}
              />
          <TextField
                variant="outlined"
                fullWidth 
                style={{ marginTop: 11 }}
                label={'Section parent Class'}
                value={listData.sectionParentClass}
                onChange={(e) => setListData({ ...listData, sectionParentClass: e.target.value })}
            />
          <GriderLayout left={'Use Grid CSS'} 
              right={<input
                type="checkbox"
                value={true}
                checked={listData.useGridCss}
                onChange={(e) => setListData({ ...listData, useGridCss: e.target.checked })}
              />} 
            />
        <br />                
        <GriderLayout left={'Use Block Version'} 
              right={<input
                type="checkbox"
                value={'block'}
                checked={(listData.version==='block')}
                onChange={(e) => setListData({ ...listData, version: e.target.checked ? 'block' : 'old' })}
              />} 
            />
        <GriderLayout left={'Hide'} 
          right={<input
            type="checkbox"
            value={true}
            checked={listData.isHidden}
            onChange={(e) => setListData({ ...listData, isHidden: e.target.checked})}
          />} 
        />
  <Button variant='outlined' color='primary' className='my-5' fullWidth onClick={handleSave}>Save</Button>
    </div>
  );
};

export default HtmlForm;
